import { atom } from "jotai";
import { HttpStatusCodes } from "../../utils/axios";

export const httpStatusCode = atom<HttpStatusCodes | undefined>(undefined);
